if (!customElements.get('results-pagination')) {
  customElements.define(
    'results-pagination',
    class ResultsPagination extends HTMLElement {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
      }

      connectedCallback () {
        this.elements = {
          loadMoreButton: this.querySelector('[data-results-pagination-el="loadMoreButton"]'),
          label: this.querySelector('[data-results-pagination-el="label"]'),
          externalLabel: document.querySelector('[data-results-pagination-el="externalLabel"]'),
        }

        this.setupEventListeners()

        this.onPaginationUpdated = pagination => this.renderPagination(pagination)
        this.eventBus.subscribe(
          window.theme.results.events.STATE.PAGINATION_UPDATED,
          this.onPaginationUpdated,
        )
      }

      disconnectedCallback () {
        this.eventBus.unsubscribe(
          window.theme.results.events.STATE.PAGINATION_UPDATED,
          this.onPaginationUpdated,
        )
      }

      renderPagination (pagination) {
        if (pagination.total === 0) {
          this.setAttribute('hidden', 'true')

          this.elements.externalLabel.textContent = `Showing 0 results found for "${window.theme.results.stateLayer.state.activeTerm}"`

          document.querySelector('.clc-Collection_Controls').setAttribute('hidden', 'true')

          return
        }

        if (this.elements.label) {
          const start = pagination.total === 0 ? 0 : pagination.from + 1
          const end = Math.min(pagination.from + pagination.size, pagination.total)
          this.elements.label.textContent = `Showing ${start}-${end} of ${pagination.total} products`
        }

        if (this.elements.externalLabel) {
          const start = pagination.total === 0 ? 0 : pagination.from + 1
          const end = Math.min(pagination.from + pagination.size, pagination.total)
          this.elements.externalLabel.textContent = `Viewing ${start}-${end} of ${pagination.total} products`
        }

        if (pagination.showNextButton) {
          this.elements.loadMoreButton.removeAttribute('hidden')
        } else {
          this.elements.loadMoreButton.setAttribute('hidden', 'true')
        }
      }

      setupEventListeners () {
        this.elements.loadMoreButton?.addEventListener('click', this.handleLoadMore.bind(this))
      }

      handleLoadMore () {
        this.eventBus.publish(window.theme.results.events.UI.PAGINATION_NEXT, {
          direction: 'next',
        })
      }
    },
  )
}
